import { Divider } from "@fluentui/react-components";
import logo from "../../../assets/images/logo.png";
import useHeaderStyles from "./Header.styles";
import { IconButton } from "../../../components/IconButton";
import { SignOut24Regular } from "@fluentui/react-icons";
import mobileLogo from "../../../assets/images/mobile header logo.png";
import { useIsMobile } from "../../../hooks";
import { useNavigate } from "react-router-dom";
import Typography from "../../../components/Typography";
import { customTokens } from "../../../theme/theme";
import ROUTES from "../../../constants/routes";

const Header = () => {
  const isMobile = useIsMobile();
  const styles = useHeaderStyles();
  const navigate = useNavigate();

  return (
    <>
      <header className={`${styles.header}`}>
        <div className={styles.headerContent}>
          <div className={styles.logoSection}>
            <img
              src={isMobile ? mobileLogo : logo}
              alt="UN logo"
              className={isMobile ? styles.mobileLogo : styles.logo}
              onClick={() => navigate(ROUTES.HOME)}
            />
            <Divider vertical className={styles.divider} />
            <Typography
              variant="body3Extension"
              color={customTokens.colorNeutralForegroundInverted}
            >
              Climate Data Hub
            </Typography>
          </div>

          <div className={styles.rightSection}>
            <IconButton
              icon={<SignOut24Regular />}
              className={styles.unfcccLink}
              ariaLabel="Logout"
              onClick={() => {
                localStorage.removeItem("token");
                navigate("/admin-login");
              }}
            />
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
